import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-title__main" }
const _hoisted_2 = {
  key: 0,
  class: "section-title__aside"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_ctx.text || _ctx.$slots.aside)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["section-title", { 'section-title--with-aside': Boolean(_ctx.$slots.aside) }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.titleTag), {
            class: _normalizeClass(["section-title__text", _ctx.titleClass])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.text), 1)
            ]),
            _: 1
          }, 8, ["class"])),
          (_ctx.tooltipContent)
            ? (_openBlock(), _createBlock(_component_Tooltip, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tooltipContent), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.$slots.aside)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "aside", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}